import React, {
  useRef,
  useMemo,
} from 'react';
import PropTypes from 'prop-types';
import {
  debounce,
  IconButton,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

import {
  Container,
  StyledTextField,
  StyledSearchRefractionIcon,
} from './styles';
import texts from './texts.json';

const SEARCH_TIMEOUT = 300;

const SearchBar = ({
  value,
  onChange,
  clearSearch,
  autoFocus,
  placeholder,
  className,
}) => {
  const inputRef = useRef(null);

  const handleClearSearch = () => {
    clearSearch();
    inputRef.current.value = '';
  };

  const handleSearch = useMemo(() => debounce(onChange, SEARCH_TIMEOUT), [onChange]);

  return (
    <Container className={className}>
      <StyledTextField
        inputRef={inputRef}
        onChange={handleSearch}
        placeholder={placeholder || texts.placeholder}
        autoFocus={autoFocus}
        InputProps={{
          startAdornment: <StyledSearchRefractionIcon />,
          endAdornment: (
            <IconButton
              title="Clear"
              aria-label="Clear"
              size="small"
              style={{ visibility: value ? 'visible' : 'hidden' }}
              onClick={handleClearSearch}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ),
        }}
      />
    </Container>
  );
};

SearchBar.propTypes = {
  autoFocus: PropTypes.bool,
  clearSearch: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

SearchBar.defaultProps = {
  autoFocus: false,
  placeholder: '',
  className: '',
};

export default SearchBar;
